import React from 'react'
import { LuSearch } from 'react-icons/lu'

import { useGlobalSearch } from '@/components/misc/GlobalSearch/hooks/useGlobalSearch'
import { Button } from '@/components/ui/button'
import { Kbd, KbdGroup } from '@/components/ui/kbd'
import { isMacOS } from '@/lib/helpers/helperFunctions'

/**
 * The search box shown in the app header. It's a trigger only — focusing or
 * clicking it opens the search palette (see GlobalSearchDialog).
 */
const SearchInput: React.FC = () => {
  const globalSearch = useGlobalSearch()

  function openSearch() {
    globalSearch.setSearchTerm('') // Clear old search
    globalSearch.show()
  }

  return (
    <Button
      variant="outline"
      onFocus={openSearch}
      onClick={openSearch}
      className="flex items-center justify-between min-w-100 bg-white
        hover:bg-white text-dim px-3"
    >
      <span className="flex items-center gap-3">
        <LuSearch className="" />
        Search referrals, clients or companies...
      </span>

      <KbdGroup className="text-dim">
        {isMacOS() ? (
          <>
            <Kbd>⌘</Kbd>
            <span className="text-xs">+</span>
            <Kbd>K</Kbd>
          </>
        ) : (
          <>
            <Kbd>Ctrl</Kbd>
            <span className="text-xs">+</span>
            <Kbd>/</Kbd>
          </>
        )}
      </KbdGroup>
    </Button>
  )
}

export default SearchInput
